import { useMemo } from "react";
import { AutomationTypeEnum } from "./AutomationsUtils";
import DashboardReport from "./AutomationsUseCases/DashboardReport/DashboardReport";
import TicketingQueueWizard from "./AutomationsUseCases/TicketingQueueWizard/TicketingQueueWizard";
import useOnlyVisibleToDevs from "../Auth/useOnlyVisibleToDevs/useOnlyVisibleToDevs";
import FindingsReport from "./AutomationsUseCases/FindingsReport/FindingsReport";
import { FieldsUtilsProvider } from "./AutomationsUseCases/TicketingQueueWizard/FieldsUtilsProvider";
import ViewsWizard from "./AutomationsUseCases/ViewsWizard/ViewsWizard";

export const useAutomationRouteConfig = () => {
  const isDev = useOnlyVisibleToDevs();

  const automationsUseCases = useMemo(() => {
    const baseAutomations = [
      {
        type: AutomationTypeEnum.DASHBOARD_REPORT,
        route: "dashboard-report",
        component: <DashboardReport />,
      },
      {
        type: AutomationTypeEnum.FINDINGS_REPORT,
        route: "findings-report",
        component: <FindingsReport />,
      },
      {
        type: AutomationTypeEnum.TICKETING_QUEUES,
        route: "ticketing-queue",
        component: (
          <FieldsUtilsProvider>
            <TicketingQueueWizard />
          </FieldsUtilsProvider>
        ),
      },
      {
        type: AutomationTypeEnum.VIEW,
        route: "view",
        component: <ViewsWizard />,
      },
    ];

    if (isDev) {
      return [...baseAutomations];
    }

    return baseAutomations;
  }, [isDev]);

  return { automationsUseCases };
};
